import { SadaHideMobile } from './styles';

const HideMobile = (props) => <SadaHideMobile {...props} />;

export default HideMobile;
